module.exports = {
      id: "follow-facebook-usage",
      viewBox: "0 0 29 28",
      url: __webpack_public_path__ + "svg-sprite-3f41b5422aa8d7a50bd372d0b736cd55.svg#follow-facebook",
      toString: function () {
        return this.url;
      }
    }